import { API_KEYS } from 'constants/auth';
import { getApiKeyHeader } from 'helpers/user-helpers';
import { bestpark } from './base-api';

const postLog = async (
  entity: string,
  activity: string,
  data: object,
): Promise<any> => {
  const result = await bestpark.post(
    '/logs',
    { entity, activity, data },
    getApiKeyHeader(API_KEYS.POST_LOG),
  );
  return result.data;
};

export const logsApi = {
  postLog,
};
